import tables from './tables';
import utils from '../utils';

const getLaunchMasterList = async (token) => {
  const { data: masterList } = await utils.getFromMikMakFirebaseService(
    `get/${tables.launchMasterList}`,
    token,
  );

  return masterList;
};

const writeToMasterList = async (data, queryPath, token) => {
  await utils.postToMikMakFirebaseService(
    `update/${tables.launchMasterList}/${queryPath}`,
    data,
    token,
  );
};

export default {
  getLaunchMasterList,
  writeToMasterList,
};
